export type NumberFormatLocale = 'DE' | 'EN';

export const NUMBER_FORMAT_LOCALE_OPTIONS: { value: NumberFormatLocale; label: string }[] = [
  { value: 'DE', label: 'German (1.000,00 EUR)' },
  { value: 'EN', label: 'English (1,000.00 EUR)' },
];

export function normalizeNumberFormatLocale(value: unknown): NumberFormatLocale {
  return value === 'EN' ? 'EN' : 'DE';
}

export function formatDecimalNumber(
  value: number,
  locale: NumberFormatLocale = 'DE',
  options?: { minimumFractionDigits?: number; maximumFractionDigits?: number }
): string {
  const minimumFractionDigits = options?.minimumFractionDigits ?? 2;
  const maximumFractionDigits = options?.maximumFractionDigits ?? 2;

  if (!Number.isFinite(value)) {
    return locale === 'EN' ? '0.00' : '0,00';
  }

  // Round with Number#toFixed first (half-up / JS fixed-point), then apply grouping.
  // toLocaleString alone double-rounds Axxion ratios like −0.0956499 → −9,57 instead of −9,56.
  const rounded = Number(value.toFixed(maximumFractionDigits));

  if (locale === 'EN') {
    return rounded.toLocaleString('en-US', {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits,
      maximumFractionDigits,
    });
  }

  return rounded.toLocaleString('de-DE', {
    style: 'decimal',
    useGrouping: true,
    minimumFractionDigits,
    maximumFractionDigits,
  });
}
